function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import serialize from 'serialize-javascript';
const storeHoursMock = {
  monday: {
    open: '6:00',
    close: '21:00'
  },
  tuesday: {
    open: '6:00',
    close: '21:00'
  },
  wednesday: {
    open: '6:00',
    close: '21:00'
  },
  thursday: {
    open: '6:00',
    close: '21:00'
  },
  friday: {
    open: '6:00',
    close: '21:00'
  },
  saturday: {
    open: '6:00',
    close: '21:00'
  },
  sunday: {
    open: '8:00',
    close: '20:00'
  }
};
export const ContextBuilder = {
  server(_ref) {
    var _requestData$route;
    let {
      expConfiguration = {},
      requestData = {},
      hosts = {}
    } = _ref;
    const experienceContext = {
      channel: requestData.channel || 'desktop',
      configService: _objectSpread(_objectSpread({}, expConfiguration), {}, {
        searchStream: expConfiguration === null || expConfiguration === void 0 ? void 0 : expConfiguration['search.stream'],
        searchStreamLimit: expConfiguration === null || expConfiguration === void 0 ? void 0 : expConfiguration['search.streamLimit']
      }),
      cookie: {
        adobeCookie: requestData.adobeCookie
      },
      customer: requestData.customer,
      dataType: requestData.dataType,
      deliveryZip: requestData.deliveryZip,
      experiment: requestData.experiment || {},
      hosts,
      isConsumerApp: requestData.isConsumerApp,
      isDebugMode: requestData.isDebugMode,
      isLocal: requestData.isLocal || false,
      localStoreZip: requestData.localStoreZip,
      path: ((_requestData$route = requestData.route) === null || _requestData$route === void 0 ? void 0 : _requestData$route.path) || '/',
      referer: requestData.referer,
      segment: requestData.segment,
      store: {
        storeHours: requestData.storeHours || storeHoursMock,
        storeId: requestData.storeId || '121',
        storeName: requestData.storeName || 'Cumberland',
        storeZip: requestData.localStoreZip || '30339'
      }
    };
    return {
      contextScript: `
      <script>window.__EXPERIENCE_CONTEXT__ =
      {
        "channel": ${serialize(experienceContext.channel)},
        "cookie": ${serialize(experienceContext.cookie)},
        "customer": ${serialize(experienceContext.customer)},
        "dataType": ${serialize(experienceContext.dataType)},
        "deliveryZip": ${serialize(experienceContext.deliveryZip)},
        "experiment": ${serialize(experienceContext.experiment)},
        "hosts": ${serialize(_objectSpread(_objectSpread({}, experienceContext.hosts), {}, {
        api: '',
        www: ''
      }))},
        "isConsumerApp": ${serialize(experienceContext.isConsumerApp)},
        "isDebugMode": ${serialize(experienceContext.isDebugMode)},
        "isLocal": ${serialize(experienceContext.isLocal)},
        "localStoreZip": ${serialize(experienceContext.localStoreZip)},
        "nearByStores": ${serialize(experienceContext.nearByStores)},
        "path": ${serialize(experienceContext.path)},
        "referer": ${serialize(experienceContext.referer)},
        "segment": ${serialize(experienceContext.segment)},
        "store": ${serialize(experienceContext.store)}
      }
      </script>
      `,
      experienceContext
    };
  },
  client() {
    let {
      expConfiguration = {}
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      expConfiguration: {}
    };
    const ctx = window.__EXPERIENCE_CONTEXT__ || {};
    const experienceContext = {
      channel: ctx.channel,
      configService: _objectSpread(_objectSpread({}, expConfiguration), {}, {
        searchStream: expConfiguration === null || expConfiguration === void 0 ? void 0 : expConfiguration['search.stream'],
        searchStreamLimit: expConfiguration === null || expConfiguration === void 0 ? void 0 : expConfiguration['search.streamLimit']
      }),
      cookie: ctx.cookie || {},
      customer: ctx.customer || {},
      dataType: ctx.dataType || '',
      deliveryZip: ctx.deliveryZip || '',
      experiment: ctx.experiment || {},
      hosts: ctx.hosts || {},
      isConsumerApp: ctx.isConsumerApp,
      isDebugMode: ctx.isDebugMode || false,
      isLocal: ctx.isLocal,
      localStoreZip: ctx.localStoreZip || '',
      nearByStores: ctx.nearByStores || [],
      path: ctx.path,
      referer: ctx.referer || '',
      segment: ctx.segment || '',
      store: ctx.store || {}
    };
    return {
      experienceContext
    };
  }
};
//# sourceMappingURL=context-builder.js.map